<div class="modal-header">
  <h5 class="" id="modal-title">
    ELEK Cable Pro Web - User Signup
  </h5>
  <button type="button" class="close" aria-describedby="modal-title"
    (click)="activeModal.dismiss(false)">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <app-register [isPopup]="true" [isWebFacing]="true"></app-register>
</div>